import Vue from 'vue'
import Vuex from 'vuex'
import { authApi } from '../services/api'

Vue.use(Vuex)

const savedUser = localStorage.getItem('jjzx_user')
export default new Vuex.Store({
  state: {
    token: localStorage.getItem('jjzx_token') || '',
    user: savedUser ? JSON.parse(savedUser) : null
  },
  mutations: {
    requirePasswordChange (state) {
      if (state.user) { Vue.set(state.user, 'password_change_required', true); localStorage.setItem('jjzx_user', JSON.stringify(state.user)) }
    },
    session (state, value) {
      state.token = value ? value.token : ''
      state.user = value ? value.user : null
      if (value) {
        localStorage.setItem('jjzx_token', value.token)
        localStorage.setItem('jjzx_user', JSON.stringify(value.user))
      } else {
        localStorage.removeItem('jjzx_token')
        localStorage.removeItem('jjzx_user')
      }
    }
  },
  actions: {
    async login ({ commit }, form) { const value = await authApi.login(form); commit('session', value); return value },
    async refreshProfile ({ state, commit }) {
      const user = await authApi.profile()
      commit('session', { token: state.token, user })
      return user
    },
    async logout ({ commit }) { try { await authApi.logout() } finally { commit('session', null) } }
  },
  getters: {
    can: state => permission => {
      if (state.user && state.user.password_change_required) return false
      const permissions = (state.user && state.user.permissions) || []
      return permissions.indexOf('*') >= 0 || permissions.indexOf(permission) >= 0
    }
  }
})
